/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import cacheAxios from '../../util/cacheAxios';

const genderAxios = axios.create();
const cache = new Map();
cacheAxios(genderAxios, cache);

genderAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

const legendRef = {
  bottom: '10%',
  right: '1%',
  orient: 'vertical',
  align: 'right',
};

export default {
  state: {
    genderMetas: [],
    genderCountriesInfo: {},
    distinctCountries: [],
    chartLoading: false,
    genderChartOptions: {
      title: {
        left: 'center',
        top: '1%',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      grid: {
        left: '3%',
        right: '12%',
        bottom: '35px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: [],
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
    },
  },
  mutations: {
    addGenderCountriesInfo(state, infos) {
      const g = groupBy(infos, info => `${info.seriesCode}|${info.countryCode}`);
      Object.keys(g).forEach((key) => {
        g[key] = sortBy(g[key], 'year');
      });
      state.genderCountriesInfo = {
        ...state.genderCountriesInfo,
        ...g,
      };
    },
    setDistinctCountries(state, countries) {
      state.distinctCountries = countries;
    },
    setGenderMetas(state, metas) {
      state.genderMetas = metas;
    },
    plotGenderChart(state, { req, countryInfos }) {
      const meta = state.genderMetas.find(m => m.code === req.code);
      const title = {
        ...state.genderChartOptions.title,
        text: meta ? meta.indicatorName : '',
        top: '1%',
        left: 'center',
      };
      const countries = req.countries.filter(c => state.genderCountriesInfo[`${req.code}|${c}`]);
      const legend = {
        ...legendRef,
        data: countries.map(code => countryInfos[code]),
      };
      let xAxisData = [];
      const chartsToPlot = countries.map((c) => {
        const data = state.genderCountriesInfo[`${req.code}|${c}`].map(o => ([o.year.toString(), o.value]));
        return {
          data,
          label: {
            normal: {
              show: false,
              formatter: '{a}',
            },
            emphasis: {
              show: true,
              formatter: '{a}',
            },
          },
          name: countryInfos[c],
          type: 'line',
        };
      });
      chartsToPlot.forEach((c) => {
        c.data.forEach(d => (xAxisData.push(d[0].toString())));
      });
      xAxisData = uniq(xAxisData).sort();
      const xAxis = {
        ...state.genderChartOptions.xAxis,
        data: xAxisData,
      };
      state.genderChartOptions = {
        ...state.genderChartOptions,
        title,
        xAxis,
        // yAxis,
        legend,
        series: chartsToPlot,
        clear: true,
      };
      state.chartLoading = false;
    },
  },
  actions: {
    retrieveGenderInfoDistinctCountries({ commit }) {
      genderAxios.get('/aims/api/gender/countries')
        .then((res) => {
          if (res.status === 200) {
            commit('setDistinctCountries', res.data);
            return;
          }
          throw new Error(res.statusText);
        });
    },
    retreiveGenderCountriesInfo({ commit, state, getters }, req) {
      const q = {
        ...req,
        countries: req.countries.filter(c => !state.genderCountriesInfo[`${req.code}|${c}`]),
      };
      if (q.countries.length > 0) {
        genderAxios.post('/aims/api/gender/infos', q)
          .then((res) => {
            if (res.status === 200) {
              // TODO populate genderChartOptions
              commit('addGenderCountriesInfo', res.data);
              return;
            }
            throw new Error(res.statusText);
          })
          .then(() => {
            commit('plotGenderChart', { req, countryInfos: getters.countryInfos });
          });
      } else {
        commit('plotGenderChart', { req, countryInfos: getters.countryInfos });
      }
    },
    retrieveGenderMetas({ commit }) {
      genderAxios.get('/aims/api/gender/metas')
        .then((res) => {
          if (res.status === 200) {
            commit('setGenderMetas', res.data);
          }
        });
    },
  },
  getters: {
    genderRegionsGroup(state, getters, rootState) {
      const genderCountries = state.distinctCountries;
      const regionGroup = [...rootState.econPredictor.regionsGroup];
      return regionGroup.map((region) => {
        const countryInfos = region.countryInfos
          .filter(c => genderCountries.includes(c.countryCode));
        return {
          region: region.region,
          countryInfos,
        };
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/genderModule.js